import { Navigate, Outlet } from "react-router-dom";
import PageMeta from "~/components/common/meta";
import { useAuth } from "~/store";

export const AuthLayout = () => {
  const { isAuth, user } = useAuth();

  if (isAuth && user) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <PageMeta
        title="Authentication | Art Handler"
        description="Authentication screen"
      />
      <div className="min-h-screen flex flex-col bg-[#faf8f3] relative overflow-hidden">

        {/* Content */}
        <div className="relative z-10 flex-1 flex">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
